import { FIREBASE_API_URL } from 'config';

const API_BASE_URL = process.env.API_URL || `${FIREBASE_API_URL}/api`;

export const doFetch = async (
  url: string,
  method: 'POST' | 'GET' | 'PUT' | 'DELETE' = 'POST',
  body?: any
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${url}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      ...(body && {
        body: JSON.stringify(body),
      }),
    });

    if (!response.ok) {
      // Not in the range 200-299
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    //204 No Content
    if (response.status === 204) {
      return {
        success: true,
      };
    }
    const json = await response.json();

    return json;
  } catch (error) {
    return {
      error: (error as any).message,
    };
  }
};
